import { Box, Typography } from '@mui/material';
import QuoteBanner from 'components/Quotes/QuoteBanner';

// Página de prueba, sin enlace en la navegación — solo accesible por URL directa.
// Reproduce el punto de entrada real (el banner) para que el flujo completo
// de solicitud se pueda probar antes de publicarlo en el sitio.
export default function TestFlujoSolicitud() {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', py: 6, px: 2 }}>
      <Typography variant="h5" fontWeight={800} color="#125095" gutterBottom>
        Vista de prueba — Flujo de solicitud
      </Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>
        Esta página no está enlazada desde el sitio — es solo para probar el flujo completo antes de publicarlo. Haz clic en el banner para iniciar como lo haría un paciente.
      </Typography>
      <QuoteBanner />
    </Box>
  );
}
